/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import MaterialTable from 'material-table';
import { parcoursTypes, FormatDate } from '../../../../helpers/utils';
import useSemester from './useSemester';
import SemesterUpdate from './SemesterUpdate';

const SemestersList = ({
  semestersData, setSemestersData, type, companyId, semestersArr, referentsList, isCompany,
}) => {
  const [modal, setModal] = useState(false);
  const [semesterData, setSemesterData] = useState([]);
  const { updateSemester, deleteSemester } = useSemester(companyId, semestersData, setSemestersData, type);
  const tableRef = useRef();
  return (
    <>
      <MaterialTable
        title={parcoursTypes.includes(type) ? 'Récapitulatif du parcours' : `${isCompany ? 'Parcours' : 'Liste des semestres'}`}
        style={{
          width: '100%',
          fontSize: '13px',
          color: '#4b4b4b',
        }}
        ref={tableRef}
        data={semestersData}
        columns={parcoursTypes.includes(type) ? [
          {
            title: isCompany ? 'Parcours' : 'Semestre',
            field: 'semester',
          },
          {
            title: 'Groupes',
            field: 'presentialGroups',
            render: (rowData) => {
              if (rowData.presentialGroups) {
                return rowData.presentialGroups;
              }
              return '/';
            },
          },
          {
            title: 'E-learning',
            field: 'elearningHours',
            render: (rowData) => {
              if (rowData.elearningHours) {
                return `${Math.round((rowData.elearningHours - (rowData.elearningHours % 60)) / 60)}h${rowData.elearningHours % 60 <= 9 ? '0' : ''}${Math.round(rowData.elearningHours % 60)}`;
              }
              return '/';
            },
          },
          {
            title: 'Presentiel',
            field: 'presentialHours',
            render: (rowData) => {
              if (rowData.presentialHours) {
                return `${Math.round((rowData.presentialHours - (rowData.presentialHours % 60)) / 60)}h${rowData.presentialHours % 60 <= 9 ? '0' : ''}${Math.round(rowData.presentialHours % 60)}`;
              }
              return '/';
            },
          },
          {
            title: 'Début',
            field: 'beginDate',
            width: '15%',
            render: (rowData) => FormatDate(rowData.beginDate),
          },
          {
            title: 'Fin',
            field: 'endDate',
            width: '15%',
            render: (rowData) => FormatDate(rowData.endDate),
          },
          {
            title: 'Rattrapage',
            field: 'catchUpDate',
            width: '15%',
            hidden: true,
            hiddenByColumnsButton: true,
            render: (rowData) => FormatDate(rowData.catchUpDate ? rowData.catchUpDate : null),
          },
          {
            title: 'Formateur EW',
            field: 'needFormer',
            width: '10%',
            hidden: true,
            hiddenByColumnsButton: true,
            render: (rowData) => {
              if (rowData.needFormer) {
                return 'Oui';
              }
              return 'Non';
            },
          },
          {
            title: 'Référents',
            field: 'referents',
            render: (rowData) => {
              if (rowData.referents !== undefined && rowData.referents.length > 0) {
                let res = '';
                rowData.referents.forEach((ref) => {
                  if (ref !== null) {
                    res += `${res === '' ? '' : ', '}${ref.firstname !== null ? ref.firstname : ''}`;
                  }
                });
                return res;
              }
              return 'Aucun';
            },
          },
        ]
          : [
            {
              title: isCompany ? 'Parcours' : 'Semestre',
              field: 'semester',
            },
            {
              title: 'Groupes',
              field: 'presentialGroups',
              render: (rowData) => {
                if (rowData.presentialGroups) {
                  return rowData.presentialGroups;
                }
                return '/';
              },
            },
            {
              title: 'E-learning',
              field: 'elearningHours',
              render: (rowData) => {
                if (rowData.elearningHours) {
                  return `${Math.round((rowData.elearningHours - (rowData.elearningHours % 60)) / 60)}h${rowData.elearningHours % 60 <= 9 ? '0' : ''}${Math.round(rowData.elearningHours % 60)}`;
                }
                return '/';
              },
            },
            {
              title: 'Présentiel',
              field: 'presentialHours',
              render: (rowData) => {
                if (rowData.presentialHours) {
                  return `${Math.round((rowData.presentialHours - (rowData.presentialHours % 60)) / 60)}h${rowData.presentialHours % 60 <= 9 ? '0' : ''}${Math.round(rowData.presentialHours % 60)}`;
                }
                return '/';
              },
            },
            {
              title: 'Début',
              field: 'beginDate',
              width: '15%',
              render: (rowData) => FormatDate(rowData.beginDate),
            },
            {
              title: 'Fin',
              field: 'endDate',
              width: '15%',
              render: (rowData) => FormatDate(rowData.endDate),
            },
            {
              title: 'Rattrapage',
              field: 'catchUpDate',
              width: '15%',
              hidden: true,
              hiddenByColumnsButton: true,
              render: (rowData) => FormatDate(rowData.catchUpDate ? rowData.catchUpDate : null),
            },
            {
              title: 'Formateur EW',
              field: 'needFormer',
              width: '15%',
              hidden: true,
              hiddenByColumnsButton: true,
              render: (rowData) => {
                if (rowData.needFormer) {
                  return 'Oui';
                }
                return 'Non';
              },
            },
            {
              title: 'Référents',
              field: 'referents',
              render: (rowData) => {
                if (rowData.referents !== undefined && rowData.referents.length > 0) {
                  let res = '';
                  rowData.referents.forEach((ref) => {
                    if (ref !== null) {
                      res += `${res === '' ? '' : ', '}${ref.firstname !== null ? ref.firstname : ''}`;
                    }
                  });
                  return res;
                }
                return 'Aucun';
              },
            },
          ]}
        options={{
          pageSize: 10,
          columnsButton: true,
          pageSizeOptions: [5, 10, 20],
        }}
        localization={{
          header: {
            actions: '',
          },
          toolbar: {
            searchPlaceholder: 'Rechercher..',
          },
          body: {
            emptyDataSourceMessage: isCompany ? 'Aucun parcours' : 'Aucun semestre.',
            editRow: {
              deleteText: `Archiver ce ${isCompany ? 'parcours' : 'semestre'} ?`,
            },
            deleteTooltip: 'Supprimer',
          },
        }}
        actions={[
          {
            icon: 'edit',
            tooltip: parcoursTypes.includes(type) || isCompany ? 'modifier parcours' : 'modifier semestre',
            onClick: (event, rowData) => {
              setSemesterData(rowData);
              setModal(true);
            },
          },
        ]}
        editable={{
          onRowDelete: (oldData) => new Promise((resolve) => {
            deleteSemester(oldData._id);
            resolve();
          }),
        }}
      />
      <Dialog
        open={modal}
        onClose={() => setModal(false)}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {`Mise à jour ${isCompany ? 'parcours' : 'semestre'}`}
        </DialogTitle>
        <DialogContent>
          <SemesterUpdate
            data={semesterData}
            isCompany={isCompany}
            setModal={setModal}
            closeModal={() => setModal(false)}
            semestersArr={semestersArr}
            referentsList={referentsList}
            updateSemester={updateSemester}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModal(false)} color="primary">
            Fermer
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

SemestersList.propTypes = {
  type: PropTypes.string.isRequired,
  semestersData: PropTypes.array.isRequired,
  setSemestersData: PropTypes.func.isRequired,
  companyId: PropTypes.string.isRequired,
  isCompany: PropTypes.bool.isRequired,
  semestersArr: PropTypes.array.isRequired,
  referentsList: PropTypes.array.isRequired,
};

export default SemestersList;
